export const BRAND_NAME = 'GIRAFFE ENTERTAINMENT & EXPERIENCES';
export const BRAND_SHORT_NAME = 'GIRAFFE';
export const BRAND_ASSETS = {
  symbol: '/media/brand/giraffe-symbol.png',
  wordmark: '/media/brand/giraffe-wordmark.png',
};